import { render, staticRenderFns } from "./Acordo.vue?vue&type=template&id=4fea12b6&scoped=true&"
import script from "./Acordo.vue?vue&type=script&lang=js&"
export * from "./Acordo.vue?vue&type=script&lang=js&"
import style0 from "./Acordo.vue?vue&type=style&index=0&id=4fea12b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea12b6",
  null
  
)

export default component.exports